// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"7d2389c0","985":"d7c6d668"}[chunkId] + ".chunk.css";
};